import { useEffect, useState } from 'react';
import { getDatabase, ref, onValue, runTransaction } from 'firebase/database';

const encodeKey = (name) => name.replace(/[./#$[\]]/g, '_');

const usePlayCounts = () => {
  const [playCounts, setPlayCounts] = useState({});

  useEffect(() => {
    const db = getDatabase();
    const unsub = onValue(ref(db, 'playCounts'), (snapshot) => {
      setPlayCounts(snapshot.val() || {});
    });
    return unsub;
  }, []);

  const incrementPlayCount = (trackName) => {
    const db = getDatabase();
    runTransaction(ref(db, `playCounts/${encodeKey(trackName)}`), (count) => (count || 0) + 1);
  };

  return { playCounts, incrementPlayCount, encodeKey };
};

export default usePlayCounts;
